/* @ts-ignore */
import UserAvatar from "react-user-avatar";
import "./NavbarTransparent.css";
import { useNavigate, useLocation } from "react-router-dom";
import Currency from "../Currency";
import { useState } from "react";
import { useSelector } from "react-redux";
import Avatar from "../Avatar";
import LoginProc from "../../Auth/LoginProc";
import { GiHamburgerMenu } from "react-icons/gi";
import { useModal } from "../../Sliders/Modal/ModalContext";
import { FaUser } from "react-icons/fa";

const LeftComp = ({ navigate }: any) => {
  return (
    <div className="flex items-center flex-1">
      <div
        className="cursor-pointer w-36 md:w-48"
        onClick={() => navigate("/")}
      >
        <img
          src="https://stavigo.s3.us-west-2.amazonaws.com/Stavigo+(3).png"
          className="w-full h-full"
        />
      </div>
    </div>
  );
};

const CenterNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isFlights = location.pathname.startsWith("/flights");
  const isInterstate = location.pathname.startsWith("/interstate");
  // const isLagBus = location.pathname.startsWith("/lagbus");  // LagBus hidden
  const isTrain = location.pathname.startsWith("/train");
  const isCowry = location.pathname.startsWith("/cowry");

  return (
    <nav className="hidden md:flex items-center gap-8">
      <span
        className="underline-animation cursor-pointer"
        style={{
          fontWeight: 600,
          fontSize: 15,
          color: isFlights ? "#FF6A1A" : "inherit",
        }}
        onClick={() => navigate("/flights")}
      >
        Flights
      </span>
      <span
        className="underline-animation cursor-pointer"
        style={{
          fontWeight: 600,
          fontSize: 15,
          color: isInterstate ? "#FF6A1A" : "inherit",
        }}
        onClick={() => navigate("/interstate")}
      >
        Bus
      </span>
      {/* LagBus link hidden for now — the /lagbus route still resolves. */}
      <span
        className="underline-animation cursor-pointer"
        style={{
          fontWeight: 600,
          fontSize: 15,
          color: isTrain ? "#FF6A1A" : "inherit",
        }}
        onClick={() => navigate("/train")}
      >
        Train
      </span>
      <span
        className="underline-animation cursor-pointer"
        style={{
          fontWeight: 600,
          fontSize: 15,
          color: isCowry ? "#FF6A1A" : "inherit",
        }}
        onClick={() => navigate("/cowry")}
      >
        Cowry
      </span>
    </nav>
  );
};

const RightComp = ({ currency }: any) => {
  return (
    <div className="hidden md:flex gap-4 flex-1 justify-end items-center">
      <div className="hover:bg-[#3a3a3a40] hover:rounded px-2 flex justify-center items-center cursor-pointer">
        <span className="font-medium text-base">Help</span>
      </div>
      <div className="hover:bg-[#3a3a3a40] hover:rounded px-2 flex justify-center items-center cursor-pointer">
        <a
          className="no-underline text-white hover:text-white hover:no-underline focus:text-white focus:no-underline"
          href={
            currency && currency.country === "NG"
              ? "tel:+234 (201) 350-3000"
              : "tel:+1 (888) 665-3405"
          }
        >
          <span className="font-medium text-base">Support</span>
        </a>
      </div>
      <Currency />
      <Avatar />
    </div>
  );
};

const RightComp2 = ({ showModal, isAuth }: any) => {
  return (
    <div className="md:hidden flex space-x-2 justify-end items-center">
      {!isAuth && (
        <div onClick={() => showModal("authModal")}>
          <FaUser className="hover:bg-[#3a3a3a40] hover:rounded px-2 text-4xl justify-center items-center cursor-pointer" />
        </div>
      )}
      <div
        onClick={() => showModal("settingModal")}
        className="hover:bg-[#3a3a3a40] hover:rounded px-2 text-3xl justify-center items-center cursor-pointer"
      >
        <GiHamburgerMenu />
      </div>
    </div>
  );
};

const NavbarTransparent = () => {
  const navigate = useNavigate();
  const { showModal } = useModal();
  const isAuth = useSelector((state: any) => state.client.isAuth);
  const currency = useSelector((state: any) => state.app.currency);
  const [isOpen2, setIsOpen2] = useState(false);

  return (
    <div
      id="navigate"
      className="absolute z-50 py-4 px-4 md:px-8 w-full text-white"
    >
      <LoginProc isOpen={isOpen2} setIsOpen={setIsOpen2} />
      <div className="flex w-full items-center">
        <LeftComp navigate={navigate} />
        <CenterNav />
        <RightComp currency={currency} />
        <RightComp2 showModal={showModal} isAuth={isAuth} />
      </div>
    </div>
  );
};

export default NavbarTransparent;
